export const DEFAULT_FILTER_OPTIONS = {
  filter: true,
  filterMatchModeOptions: [
    { label: 'Contains', value: 'contains' },
    { label: 'Equals', value: 'equals' },
  ],
  showAddButton: false,
  showApplyButton: false,
  showClearButton: false,
  filterMenuStyle: { minWidth: '230px' },
}

export const DEFAULT_NUMBER_OPTIONS = {
  filter: true,
  filterMatchModeOptions: [
    { label: 'Less Than', value: 'lt' },
    { label: 'Less Than or Equal To', value: 'lte' },
    { label: 'Greater Than', value: 'gt' },
    { label: 'Greater Than or Equal To', value: 'gte' },
  ],
  showAddButton: false,
  showApplyButton: false,
  showClearButton: false,
  filterMenuStyle: { minWidth: '230px' },
}

export const CUSTOM_FILTER_OPTIONS = {
  filter: true,
  showFilterMatchModes: false,
  showFilterOperator: false,
  showAddButton: false,
  showApplyButton: false,
  showClearButton: false,
  filterMenuStyle: { minWidth: '230px' },
}
